<app-menu [menuModuleEnum]='menuModuleEnum' [menuFunctionalityEnum]='menuFunctionalityEnum'></app-menu>

<div class="container-body">
    <h1>Subgrupos</h1>
    <div class="white-body">
        <a mat-button class="btn-primary add-user" routerLink="/consulting/template-subgroup/resgister">
            <mat-icon aria-hidden="false" aria-label="Plus">add</mat-icon> Cadastrar Subgroupo
        </a>
        <div class="filters">
            <div class="row">
                <div class="col-12 col-md-4">
                    <mat-form-field appearance="outline">
                        <mat-icon matPrefix class="my-icon">search</mat-icon>
                        <mat-label>Pesquisar</mat-label>
                        <input matInput type="text" id="searchText" name="searchText" [(ngModel)]="searchText"
                            (keyup)="onKeySearch($event)">
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-4">
                    <mat-form-field appearance="outline">
                        <mat-label>Templates</mat-label>
                        <mat-select [(ngModel)]="idTemplate" (selectionChange)="search()">
                            <mat-option>
                                Todos
                            </mat-option>
                            <mat-option *ngFor="let item of listTemplate" value="{{item.idTemplate}}">
                                {{item.templateName}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="card-list" *ngIf="listTemplateSubgroup != null">
            <div class="row">
                <div class="col-12 col-sm-6 col-md-4" *ngFor="let item of listTemplateSubgroup">

                    
                    <div class="card-item">
                        <div class="infos">
                            <span class="primary">{{item.medicineSubgroupName}}</span>
                            <span class="secundary">{{item.templateName}}</span>
                            <span class="secundary">{{item.medicineTypeName}}</span>
                            <span class="secundary">{{item.medicineGroupName}}</span>
                        </div>
                        <div class="actions">
                            <a>
                                <mat-icon aria-hidden="false" aria-label="Editar"
                                    [routerLink]="['/consulting/template-subgroup/resgister', {idMedicineSubgroup: item.idMedicineSubgroup}]">
                                    edit</mat-icon>
                            </a>
                            <a>
                                <mat-icon aria-hidden="false" aria-label="Excluir"
                                    (click)="openModal(item.idMedicineSubgroup)">delete_forever</mat-icon>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <app-empty-list *ngIf="listTemplateSubgroup != undefined && listTemplateSubgroup.length == 0"></app-empty-list>
    </div>

    <app-loading-list *ngIf="isLoading"></app-loading-list>
</div>